/* Aliens theme JS — size guide, variant pickers, AJAX cart drawer, image carousels */
(function () {
  'use strict';

  /* ---------- product image carousel (auto-slide + swipe) ---------- */

  function initCarousel(car) {
    if (car.__carouselInit) return;
    car.__carouselInit = true;

    var track = car.querySelector('[data-carousel-track]');
    var slides = car.querySelectorAll('.carousel-slide');
    var dots = car.querySelectorAll('[data-carousel-dot]');
    var count = slides.length;
    if (!track || count <= 1) return;

    var index = 0;
    var timer = null;
    var startX = null;
    var deltaX = 0;
    var dragging = false;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(i) {
      index = (i + count) % count;
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      dots.forEach(function (d, di) {
        d.classList.toggle('active', di === index);
      });
    }

    function startAuto() {
      if (reduceMotion) return;
      stopAuto();
      timer = setInterval(function () { go(index + 1); }, 4000);
    }

    function stopAuto() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    var nextBtn = car.querySelector('[data-carousel-next]');
    var prevBtn = car.querySelector('[data-carousel-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); go(index + 1); startAuto(); });
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); go(index - 1); startAuto(); });
    dots.forEach(function (d, di) {
      d.addEventListener('click', function (e) { e.preventDefault(); go(di); startAuto(); });
    });

    function onStart(x) {
      dragging = true;
      startX = x;
      deltaX = 0;
      track.style.transition = 'none';
      stopAuto();
    }

    function onMove(x) {
      if (!dragging) return;
      deltaX = x - startX;
      var pct = -index * 100 + (deltaX / car.offsetWidth) * 100;
      track.style.transform = 'translateX(' + pct + '%)';
    }

    function onEnd() {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      if (Math.abs(deltaX) > car.offsetWidth * 0.2) {
        go(deltaX < 0 ? index + 1 : index - 1);
      } else {
        go(index);
      }
      startAuto();
    }

    track.addEventListener('touchstart', function (e) { onStart(e.touches[0].clientX); }, { passive: true });
    track.addEventListener('touchmove', function (e) { onMove(e.touches[0].clientX); }, { passive: true });
    track.addEventListener('touchend', onEnd);

    track.addEventListener('mousedown', function (e) { e.preventDefault(); onStart(e.clientX); });
    window.addEventListener('mousemove', function (e) { if (dragging) onMove(e.clientX); });
    window.addEventListener('mouseup', onEnd);

    /* don't follow the product link if the user was dragging */
    car.querySelectorAll('.carousel-slide').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (Math.abs(deltaX) > 6) e.preventDefault();
      });
    });

    car.addEventListener('mouseenter', stopAuto);
    car.addEventListener('mouseleave', startAuto);

    go(0);
    /* stagger so cards don't all flip in lockstep */
    setTimeout(startAuto, Math.random() * 2500);
  }

  function initCarousels(root) {
    (root || document).querySelectorAll('[data-carousel]').forEach(initCarousel);
  }

  var toastTimer;

  function showToast(message) {
    var toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('show');
    }, 2200);
  }

  function bumpCartBtn() {
    var btn = document.getElementById('cartBtn');
    if (!btn) return;
    btn.classList.remove('bump');
    void btn.offsetWidth;
    btn.classList.add('bump');
  }

  /* ---------- cart drawer open/close (body class survives re-renders) ---------- */

  function openDrawer() {
    document.body.classList.add('cart-open');
    var drawer = document.getElementById('cartDrawer');
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    document.body.classList.remove('cart-open');
    var drawer = document.getElementById('cartDrawer');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  }

  /* ---------- cart section re-render ---------- */

  function replaceDrawer(sectionHtml) {
    var wrapper = document.getElementById('shopify-section-cart-drawer');
    if (!wrapper || !sectionHtml) return;
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var inner = doc.getElementById('shopify-section-cart-drawer');
    wrapper.innerHTML = inner ? inner.innerHTML : sectionHtml;

    var drawer = document.getElementById('cartDrawer');
    var count = drawer ? drawer.getAttribute('data-item-count') : null;
    if (count !== null) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
      });
    }
    if (document.body.classList.contains('cart-open') && drawer) {
      drawer.setAttribute('aria-hidden', 'false');
    }
  }

  function setDrawerLoading(loading) {
    var drawer = document.getElementById('cartDrawer');
    if (drawer) drawer.classList.toggle('is-loading', loading);
  }

  function addToCart(variantId, quantity, toastMessage) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: quantity || 1,
        sections: 'cart-drawer'
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          showToast(data.description || 'Could not add to cart');
          return;
        }
        if (data.sections) replaceDrawer(data.sections['cart-drawer']);
        bumpCartBtn();
        if (toastMessage) showToast(toastMessage);
        openDrawer();
      })
      .catch(function () {
        showToast('Could not add to cart');
      });
  }

  function changeCartLine(line, quantity) {
    setDrawerLoading(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: Number(line),
        quantity: Number(quantity),
        sections: 'cart-drawer'
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.sections) replaceDrawer(data.sections['cart-drawer']);
      })
      .finally(function () {
        setDrawerLoading(false);
      });
  }

  /* ---------- event delegation (survives drawer re-renders) ---------- */

  document.addEventListener('click', function (e) {
    var target;

    if (e.target.closest('#cartBtn')) {
      e.preventDefault();
      openDrawer();
      return;
    }

    if (e.target.closest('#drawerClose') || e.target.closest('#drawerOverlay') || e.target.closest('[data-drawer-close-link]')) {
      closeDrawer();
      return;
    }

    target = e.target.closest('[data-cart-qty]');
    if (target) {
      changeCartLine(target.getAttribute('data-line'), target.getAttribute('data-quantity'));
      return;
    }

    /* product card: size pill selection */
    target = e.target.closest('[data-size-opt]');
    if (target && !target.disabled) {
      var card = target.closest('[data-product-card]');
      if (card) {
        var wasSelected = target.classList.contains('selected');
        card.querySelectorAll('[data-size-opt]').forEach(function (opt) {
          var selected = opt === target && !wasSelected;
          opt.classList.toggle('selected', selected);
          opt.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
      }
      return;
    }

    /* product card: add to cart */
    target = e.target.closest('[data-add-to-cart]');
    if (target && !target.disabled) {
      var title = target.getAttribute('data-product-title') || 'Item';
      var cardEl = target.closest('[data-product-card]');
      var hasSizes = cardEl ? cardEl.querySelector('[data-size-opt]') : null;
      var size = cardEl ? cardEl.querySelector('[data-size-opt].selected') : null;
      if (hasSizes && !size) {
        showToast('Pick a size first, specimen');
        return;
      }
      var variantId = size ? size.getAttribute('data-variant-id') : target.getAttribute('data-variant-id');
      var message = size ? title + ' (' + size.textContent.trim() + ') beamed into cart' : title + ' beamed into cart';
      addToCart(variantId, 1, message);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- size guide ---------- */

  document.querySelectorAll('[data-guide-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      document.querySelectorAll('[data-guide-tab]').forEach(function (t) {
        t.classList.toggle('active', t === tab);
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      var chest = document.getElementById('measureChest');
      var length = document.getElementById('measureLength');
      var sleeve = document.getElementById('measureSleeve');
      var note = document.getElementById('fitNote');
      if (chest) chest.textContent = tab.getAttribute('data-chest');
      if (length) length.textContent = tab.getAttribute('data-length');
      if (sleeve) sleeve.textContent = tab.getAttribute('data-sleeve');
      if (note) note.textContent = tab.getAttribute('data-note');
    });
  });

  /* ---------- product page ---------- */

  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    var variantInput = productForm.querySelector('[data-variant-input]');
    var variantsScript = productForm.querySelector('[data-variants-json]');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var pricesScript = productForm.querySelector('[data-variant-prices]');
    var variantPrices = pricesScript ? JSON.parse(pricesScript.textContent) : {};
    var priceEl = document.querySelector('[data-product-price]');
    var addPriceEl = productForm.querySelector('[data-add-price]');
    var addBtn = productForm.querySelector('[data-product-add]');
    var qtyInput = productForm.querySelector('[data-qty-input]');

    /* store-formatted price (matches the shop currency, e.g. LE) */
    function priceFor(variant) {
      return variantPrices[variant.id] || '';
    }

    function selectedOptions() {
      var opts = [];
      productForm.querySelectorAll('[data-option-index]').forEach(function (row) {
        var selected = row.querySelector('.size-opt.selected');
        opts[Number(row.getAttribute('data-option-index'))] = selected ? selected.getAttribute('data-option-value') : null;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (value, i) {
          return value === null || v.options[i] === value;
        });
      });
    }

    productForm.querySelectorAll('[data-option-index]').forEach(function (row) {
      row.addEventListener('click', function (e) {
        var pill = e.target.closest('.size-opt');
        if (!pill) return;
        var wasSelected = pill.classList.contains('selected');
        row.querySelectorAll('.size-opt').forEach(function (opt) {
          var selected = opt === pill && !wasSelected;
          opt.classList.toggle('selected', selected);
          opt.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        var opts = selectedOptions();
        var allChosen = opts.every(function (v) { return v !== null; });
        if (!allChosen) {
          variantInput.value = '';
          return;
        }
        var variant = findVariant(opts);
        if (!variant) {
          variantInput.value = '';
          return;
        }
        variantInput.value = variant.id;
        if (priceEl && priceFor(variant)) priceEl.textContent = priceFor(variant);
        if (addBtn) {
          addBtn.disabled = !variant.available;
          if (variant.available && addPriceEl && priceFor(variant)) {
            addPriceEl.textContent = priceFor(variant);
          } else if (!variant.available) {
            addBtn.textContent = 'Sold Out';
          }
        }
      });
    });

    productForm.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = btn.hasAttribute('data-qty-plus') ? 1 : -1;
        qtyInput.value = Math.max(1, Number(qtyInput.value || 1) + delta);
      });
    });

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var rows = productForm.querySelectorAll('[data-option-index]');
      var allSelected = Array.prototype.every.call(rows, function (row) {
        return row.querySelector('.size-opt.selected');
      });
      if (rows.length && !allSelected) {
        showToast('Pick a size first, specimen');
        return;
      }
      if (!variantInput.value) {
        showToast('That combo is unavailable');
        return;
      }
      var titleEl = document.querySelector('.product-title');
      var title = titleEl ? titleEl.textContent.trim() : 'Item';
      addToCart(variantInput.value, Number(qtyInput.value || 1), title + ' beamed into cart');
    });

    /* gallery thumbnails */
    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var main = document.getElementById('ProductMainImage');
        if (!main) return;
        main.src = thumb.getAttribute('data-full');
        document.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.classList.toggle('active', t === thumb);
        });
      });
    });
  }

  /* ---------- init carousels ---------- */
  initCarousels();

  /* re-init if a section is re-rendered in the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    initCarousels(e.target);
  });
})();
